import { render, staticRenderFns } from "./MflTableOld.vue?vue&type=template&id=1d909052"
import script from "./MflTableOld.vue?vue&type=script&lang=js"
export * from "./MflTableOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports